import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate, useParams }  from "react-router";
import { FormattedMessage } from "react-intl";
import { Layout } from "../Layout";
import { Routes } from "constants/routes";
import { Title } from "components/Auth/components/Title";
import { Text } from "components/Auth/components/Text";
import { Button } from "ui-kit/Button";
import axios from "axios";
import { API_BASE_URL, API_URLS } from "constants/api";
import {toast} from "react-toastify";

export const SignUpConfirm = () => {
  const navigate = useNavigate();
  const params = useParams<{ id: string; token: string }>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      if (!params.id || !params.token) {
        return navigate(Routes.SignIn);
      }

      const url = API_URLS.SignUpVerify.replace('{id}', params.id).replace('{hash}', params.token);
      try {
        const response = await axios.get(`${API_BASE_URL}${url}`);
        const {success} = response.data;

        if (success) {
          setIsLoading(false);
        } else {
         navigate(Routes.SignIn);
        }
      } catch (e: any) {
        const message = e.response.data.message;
        console.error("Error", message);
        toast.error(message);
        navigate(Routes.SignIn);
      }
    })();
  }, []);

  const onGetStart = () => navigate(Routes.SignIn);

  if (isLoading) {
    return (
      <Layout>
        'Loading'
      </Layout>
    );
  }

  return (
    <Layout>
      <Container>
        <Title>
          <FormattedMessage id="Auth.SignUp.Completed.Title" defaultMessage="Registration completed"/>
        </Title>
        <Subtitle>
          <FormattedMessage id="Auth.SignUp.Completed.Subtitle" defaultMessage="You have verified your account and are ready to get started"/>
        </Subtitle>
        <Button onClick={onGetStart}>
          <FormattedMessage id="Auth.SignUp.Completed.Button" defaultMessage="Get started"/>
        </Button>
      </Container>
    </Layout>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 54px;
  height: 100%;
  max-width: 548px;

  @media (max-width: 1200px) {
    max-width: 100%;
  }
`;

const Subtitle = styled(Text)`
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
`;
